/**
 * Created by ianandersen on 4/5/17.
 */

import React from 'react';

class Title extends React.Component {
  constructor(props) {
    super(props);
    this.text = props.text;
  }

  render() {
    return this.text ? (
      <h1 style={{marginBottom: '2px'}}>
        {this.text}
        {this.props.date ? (
          <span>
            <br />
            <small> {this.props.date}</small>
          </span>
        ) : null}
      </h1>
    ) : null;
  }
}

export default Title;
